import React, { forwardRef } from 'react';
import WidenColumnPairedWithText from '../text-pairing/WidenColumn';
const WidenColumn = forwardRef((props, ref) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", height: "1em", role: "img", ref: ref, ...props },
    React.createElement("path", { d: "M11.25 0v24h1.5V0h-1.5Z", fill: "currentColor" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m0 12 6.75-6.75 1.06 1.06L2.122 12l5.69 5.69-1.061 1.06L0 12ZM24 12l-6.75-6.75-1.06 1.06L21.878 12l-5.69 5.69 1.061 1.06L24 12Z", fill: "currentColor" }))));
WidenColumn.displayName = 'WidenColumn';
// @ts-ignore;
const iconData = {
    glyph: WidenColumn,
    group: 'basic',
    textPairingGlyph: WidenColumnPairedWithText,
};
export default iconData;
